import PropTypes from "prop-types";
import { Popup } from "semantic-ui-react";
import { Mid, Value } from "./styles";

export const MidWithHover = ({ content, theme, width, category }) => {
  return (
    <Popup
      basic
      content={`${content} hours ${category}`}
      trigger={
        <Mid width={width} style={theme}>
          <Value>{content}</Value>
        </Mid>
      }
    />
  );
};

MidWithHover.propTypes = {
  content: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
  width: PropTypes.PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
};
